import {
  Component,
  ViewChild,
  ViewContainerRef, ElementRef, OnInit, AfterViewInit, HostListener
} from '@angular/core';
import { InputBaseComponent } from '../input-base.component';
import { breakpoints } from '../../environments/environment.breakpoints';

@Component({
  selector: 'ct-receipt',
  templateUrl: './ct-receipt.component.html',
  styleUrls: ['./ct-receipt.component.css'],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()',
    '[class]': 'getStyleClass()',
    '[style]': 'getCustomCss()'
  }
})
export class CtReceiptComponent extends InputBaseComponent implements AfterViewInit, OnInit {

  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  private title: string;
  private total: number;
  public integerPart: string;
  public decimalPart: string;

  //util
  public isMedium: boolean;
  public isSmall: boolean;
  public isExtraSmall: boolean;

  //functions
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    const screenWidth = window.innerWidth;
    this.isMedium = screenWidth >= breakpoints.L;
    this.isSmall = screenWidth < breakpoints.L && screenWidth > breakpoints.M;
    this.isExtraSmall = screenWidth <= breakpoints.M && screenWidth > breakpoints.S;
  }
  
  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.checkScreenSize();
  }

  ngAfterViewInit() {
    this.paintChildren(this.getMetaData(), this.target);
    this.executeEvent();
    this.setTotalAmount(this.total);
  }

  public setTotalAmount(total: number): void {
    this.total = total;
    const numberString = this.getTotal();
    const [integerPart, decimalPart] = numberString.split('.');

    this.integerPart = integerPart;
    this.decimalPart = decimalPart;
  }

  public executeEvent(): void {
    let action = this.getEvent('onInit');
    if (action) {
      this.executeAction2(action);
    }
  }

  getTitle(): string { return this.title }
  setTitle(title: string): void { this.title = title }

  getTotal(): string { 
    var value=(this.total.toFixed(2))
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}

    
  setTotal(total: number): void {
    this.setTotalAmount(total);
   }
}